// @ts-expect-error imported library for which we don't have types
import { tgaParseMettlerToledo } from 'physical-chemistry-parser';
import { Analysis } from '../index.js';
export function fromMettlerToledo(arrayBuffer) {
    const analysis = new Analysis();
    const results = tgaParseMettlerToledo(arrayBuffer);
    // we try to find the right results
    const result = results.find((result) => result.variables?.y &&
        (result.variables.y.units === 'mg' || result.variables.y.units === '%'));
    const cheminfo = { meta: result.meta };
    analysis.pushSpectrum(result.variables, {
        dataType: 'TGA',
        meta: { ...result.meta, cheminfo },
    });
    return analysis;
}
//# sourceMappingURL=fromMettlerToledo.js.map